/* eslint-disable jsx-a11y/anchor-is-valid */

import { itemsService } from "../../../services/items.service";
import { useEffect, useState, useContext } from "react";
import underscore from "underscore";
import { useForm } from "react-hook-form";
import "../ItemInformation.css";
import TypeSelect from "./TypeSelect";
import ItemReturnable from "./ItemReturnable";
import DimentionSelect from "./DimensionSelect";
import AddItemTrackingTypeCheckRadioButton from "./AddItemTrackingTypeCheckRadioButton";
import {
  GetItemToEdit,
  GetItemMasterData,
  SetItemToEdit,
} from "../../../store/itemAtom";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import GeneralDropDown from "../../../helpers/GeneralDropDown";
import NotificationContext from "../../../Context/NotificationContext";
import GeneralModal from "../../../helpers/GeneralModal";
import { createModal } from "react-modal-promise";
import LogicContext from "../../../Context/LogicContext";
import FormGroup from "@mui/material/FormGroup";
import Switch from "@mui/material/Switch";
import FormControlLabel from "@mui/material/FormControlLabel";
import ImageSlotSelection from "../../image_upload/ImageSlotSelection";
import AddItemFormGroupSelect from "../../item_group/AddItemFormGroupSelect";
import { formatFormError } from "../../../helpers/formartFormError";

const slot_info = [
  { Code: 0, Name: "Please Select" },
  ...Array.from({ length: 11 }, (_, i) => ({ Code: i + 1, Name: String(i + 1) })),
];

function AddItemForm(props) {
  const navigate = useNavigate();
  const logicContext = useContext(LogicContext);
  const myPromiseModal = createModal(GeneralModal);
  const setItemToEdit = SetItemToEdit();
  const itemToEdit = GetItemToEdit();
  const getMasterData = GetItemMasterData();
  const notificationContext = useContext(NotificationContext);

  const [defaultCurrency, setDefaultCurrency] = useState([]);
  const [productUnit, setProductUnit] = useState([]);
  const [productBrand, setProductBrand] = useState([]);
  const [productCategory, setProductCategory] = useState([]);
  const [productManufacturer, setProductManufacturer] = useState([]);
  const [productDimension, setProductDimension] = useState([]);
  const [productWeight, setProductWeight] = useState([]);
  const [salesAccounts, setSalesAccounts] = useState([]);
  const [purchaseAccounts, setPurchaseAccounts] = useState([]);
  const [inventoryAccounts, setInventoryAccounts] = useState([]);
  const [taxList, setTaxList] = useState([]);
  const [vendors, setVendors] = useState([]);
  const [itemtypeList, setItemtypeList] = useState([]);
  const [groupList, setGroupList] = useState([]);
  const [purchaseCheck, setPurchaseCheck] = useState(false);
  const [salesCheck, setSalesCheck] = useState(false);
  const [trackCheck, setTrackingCheck] = useState(false);

  const { pathname } = useLocation();
  const url = pathname.split("/");
  const currModuleId = url[1];
  const currModuleName = url[2];

  const { option } = useParams();

  useEffect(() => {
    if (!getMasterData?.length) {
      notificationContext.getMasterData();
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [getMasterData]);

  const {
    register,
    setValue,
    handleSubmit,
    reset,
    watch,
    formState: { errors },
  } = useForm();

  const outOfstock = !!watch('item_stock_out');
  const productShare = watch('product_sharing_status_id') === 1;
  const flashSales = watch('flash_sales_status_id') === 1;
  const topDeals = watch('top_deal_status_id') === 1;

  useEffect(() => {
    if (itemToEdit?.item_id) {
      setSalesCheck(!!itemToEdit.sales_accounts_id);
      setPurchaseCheck(!!itemToEdit.purchase_accounts_id);
      setTrackingCheck(!!itemToEdit.inventory_accounts_name);
      reset({
        item_id: itemToEdit.item_id,
        item_type_id: itemToEdit.item_type_id,
        item_returnable_id: itemToEdit.item_returnable_id,
        item_name: itemToEdit.item_name,
        item_category_id: itemToEdit.item_category_id,
        item_unit_id: itemToEdit.item_unit_id,
        item_brand_id: itemToEdit.item_brand_id,
        manufacturer_id: itemToEdit.manufacturer_id,
        item_dimension_length: itemToEdit.item_dimension_length,
        item_dimension_width: itemToEdit.item_dimension_width,
        item_dimension_height: itemToEdit.item_dimension_height,
        item_dimension_unit_id: itemToEdit.item_dimension_unit_id ?? 1,
        item_weight: itemToEdit.item_weight,
        item_weight_id: itemToEdit.item_weight_id,
        item_sku: itemToEdit.item_sku,
        item_isbn: itemToEdit.item_isbn,
        item_upc: itemToEdit.item_upc,
        item_ean: itemToEdit.item_ean,
        item_mpn: itemToEdit.item_mpn,
        market_rate: itemToEdit.market_rate,
        sales_rate: itemToEdit.sales_rate,
        cost_rate: itemToEdit.cost_rate,
        sales_accounts_id: itemToEdit.sales_accounts_id,
        sales_description: itemToEdit.sales_description,
        sales_tax_id: itemToEdit.sales_tax_id,
        purchase_accounts_id: itemToEdit.purchase_accounts_id,
        purchase_description: itemToEdit.purchase_description,
        purchase_tax_id: itemToEdit.purchase_tax_id,
        item_tracking_need_id: itemToEdit.item_tracking_need_id,
        inventory_accounts_id: itemToEdit.inventory_accounts_id,
        preferred_vendor_id: itemToEdit.preferred_vendor_id,
        reorder_quantity: itemToEdit.reorder_quantity,
        minimum_payment: itemToEdit.minimum_payment,
        item_variety_id: itemToEdit.item_variety_id,
        item_group_id: itemToEdit.item_group_id,
        product_sharing_status_id: itemToEdit.product_sharing_status_id,
        sharing_slot_id: itemToEdit.sharing_slot_id,
        flash_sales_status_id: itemToEdit.flash_sales_status_id,
        top_deal_status_id: itemToEdit.top_deal_status_id,
        item_tracking_type_id: itemToEdit.item_tracking_type_id,
        item_stock_out: itemToEdit.item_stock_out ? 1 : 0,
        option_allow: itemToEdit.option_allow,
      });
    } else {
      reset({ item_type_id: 1, item_weight_id: 1, item_stock_out: 1 });
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [itemToEdit?.item_id]);

  useEffect(() => {
    var masterDataGroup = underscore.groupBy(getMasterData, "Master_Type");
    setDefaultCurrency(masterDataGroup[1]);
    setProductUnit(masterDataGroup[2]);
    setProductCategory(masterDataGroup[3]);
    setProductDimension(masterDataGroup[4]);
    setProductWeight(masterDataGroup[5]);
    setProductManufacturer(masterDataGroup[6]);
    setProductBrand(masterDataGroup[7]);
    setSalesAccounts(masterDataGroup[8]);
    setPurchaseAccounts(masterDataGroup[9]);
    setTaxList(masterDataGroup[10]);
    setInventoryAccounts(masterDataGroup[11]);
    setVendors(masterDataGroup[12]);
    setItemtypeList(masterDataGroup[13]);
    setGroupList(masterDataGroup[14]);
  }, [getMasterData]);

  function selectedBrand(selection) { setValue("item_brand_id", selection.Code); }
  function selectedCategory(selection) { setValue("item_category_id", selection.Code); }
  function selectedItemType(selection) { setValue("item_variety_id", selection.Code); }
  function selectedUnitType(selection) { setValue("item_unit_id", selection.Code); }
  function selectedManufacturer(selection) { setValue("manufacturer_id", selection.Code); }
  function selectedDimensionUnit(selection) { setValue("item_dimension_unit_id", selection); }
  function selectedProductWeight(selection) { setValue("item_weight_id", selection); }
  function selectedSalesAccount(selection) { setValue("sales_accounts_id", selection.Code); }
  function selectedPurchaseAccount(selection) { setValue("purchase_accounts_id", selection.Code); }
  function selectedInventoryAccount(selection) { setValue("inventory_accounts_id", selection.Code); }
  function salesTaxList(selection) { setValue("sales_tax_id", selection.Code); }
  function selectPurchaseTax(selection) { setValue("purchase_tax_id", selection.Code); }
  function selectDefaultCurrency(selection) { setValue("currency_id", selection.Code); }
  function selectedVendor(selection) { setValue("preferred_vendor_id", selection.Code); }
  function addItemType(type) { setValue("item_type_id", type); }
  function addItemReturnable(type) { setValue("item_returnable_id", type); }
  function addItemTrackingType(type) { setValue("item_tracking_type_id", type); }
  const onSlotSelection = (sel) => { setValue("sharing_slot_id", sel.Code); };
  const onGroupSelect = (sel) => { setValue("item_group_id", sel.Code); };

  function addTrackingForItem(type) {
    if (type === true) {
      setTrackingCheck(true);
      setValue("item_tracking_need_id", 1);
    } else {
      setValue("item_tracking_need_id", 2);
      setTrackingCheck(false);
    }
  }

  const onOutOfStockChange = (event) => {
    setValue("item_stock_out", event.target.checked ? 1 : 0);
  };
  const onProductIsGrooPoolChange = (event) => {
    setValue("product_sharing_status_id", event.target.checked ? 1 : 0);
  };
  const onTopDealsChange = (event) => {
    setValue('top_deal_status_id', event.target.checked ? 1 : 0);
  };
  const onFlashSalesChange = (event) => {
    setValue('flash_sales_status_id', event.target.checked ? 1 : 0);
  };

  const onSubmit = async (formValues) => {
    const slotNumber = formValues?.sharing_slot_id || 0;
    if (formValues.product_sharing_status_id === 1 && slotNumber < 1) {
      return logicContext.showToast(
        "Since item is Gropool, you need to select product slot number!",
        ""
      );
    }

    await myPromiseModal({
      title: "Confirmation",
      body: ` Do you want to ${itemToEdit?.item_id ? "update" : "save"} this record?`,
      showInput: false,
      placeHolder: "",
    }).then((response) => {
      if (response.decision === true) {
        submitItemForm({ ...formValues, option_allow: 0 });
      }
    });
  };

  async function submitItemForm(form) {
    const getMessageData = (data) => {
      if (data?.result_status?.length) return data.result_status[0];
      if (data?.length) return data[0];
      return {};
    };

    const handleResponse = (res) => {
      const { message_text, message_ref_no } = getMessageData(res.data);
      if (message_ref_no === form.item_name || message_ref_no === form.item_sku) {
        return logicContext.showToast(message_text, "error");
      }
      const newItem = res.data?.item_info?.[0];
      if (newItem?.item_id) setItemToEdit(newItem);
      if (newItem?.item_variety_id === 2) associateItemsPrompt(newItem.item_id);
      logicContext.showToast(`${message_text}`, "success");
    };

    if (itemToEdit?.item_id) {
      itemsService.updateItem({ ...form, option_allow: 1 }).then(handleResponse);
    } else {
      itemsService.saveNewItem(form).then(handleResponse).catch(() => {});
    }
  }

  async function associateItemsPrompt(item_id) {
    const optionNum = Number(option);
    if (optionNum === 1) {
      await myPromiseModal({
        title: "Add Associated Items",
        body: " Do you want to add associated items?",
        showInput: false,
        placeHolder: "",
      }).then((result) => {
        if (result.decision === true) props.changeTab("2");
      });
    }
    if (optionNum === 2 || optionNum === 3) {
      await myPromiseModal({
        title: "New item has been saved!",
        body: " Do you want to go back to production?",
        showInput: false,
        placeHolder: "",
      }).then((result) => {
        if (result.decision === true) {
          navigate(`/${currModuleId}/${currModuleName}/production-setup/production-setup-details/${item_id}`);
        }
      });
    }
    if (optionNum === 4) {
      await myPromiseModal({
        title: "New item has been saved!",
        body: " Do you want to go back to Composite Group?",
        showInput: false,
        placeHolder: "",
      }).then((result) => {
        if (result.decision === true) {
          navigate(`/${currModuleId}/${currModuleName}/composite-item-groups/add-new`);
        }
      });
    }
  }

  function onErrors() {
    const errorMessages = formatFormError(errors);
    logicContext.showToast(errorMessages, "error");
  }

  function manageCategoryList() {
    notificationContext.showModal({ sql_ref_no_send: 27, newOption: 1, updateOption: 2, sql_ref_no_get: 28, option_get: 1 });
  }
  function manageUnitList() {
    notificationContext.showModal({ sql_ref_no_send: 27, newOption: 5, updateOption: 6, sql_ref_no_get: 28, option_get: 3 });
  }
  function manageBrandList() {
    notificationContext.showModal({ sql_ref_no_send: 27, newOption: 3, updateOption: 4, sql_ref_no_get: 28, option_get: 2 });
  }
  function manageManufacturer() {
    notificationContext.showModal({ sql_ref_no_send: 27, newOption: 7, updateOption: 8, sql_ref_no_get: 28, option_get: 4 });
  }
  function manageTaxList() {
    notificationContext.showModal({ sql_ref_no_send: 27, newOption: 13, updateOption: 14, sql_ref_no_get: 28, option_get: 7 });
  }
  function manageVendorList() {
    notificationContext.showModal({ sql_ref_no_send: 27, newOption: 15, updateOption: 16, sql_ref_no_get: 28, option_get: 8 });
  }

  return (
    <>
      <form className="" onSubmit={handleSubmit(onSubmit, onErrors)}>
        <div className="">
          {/* TYPE SECTION */}
          <div className="grid md:grid-cols-3 gap-6">
            <div>
              <TypeSelect val={itemToEdit?.item_type_id} addItemType={addItemType}></TypeSelect>
              <ItemReturnable defaultVal={itemToEdit?.item_returnable_id} addItemReturnable={addItemReturnable} />
            </div>
            <div className="">
              <label className="text-sm text-gray-600 font-medium">Select Group *</label>
              <AddItemFormGroupSelect
                list={groupList}
                defaultVal={itemToEdit?.item_group_name}
                {...register('item_group_id', { required: 'Item Group required' })}
                onGroupSelect={onGroupSelect}
              />
              <small className="text-red-500">{errors?.item_group_id && errors.item_group_id.message}</small>
            </div>

            <div className="">
              <label className="text-sm text-gray-600 font-medium">Item Variety Type *</label>
              <div className="-mt-1 w-full">
                <GeneralDropDown
                  {...register('item_variety_id', { required: 'Item Variety Type required' })}
                  defaultVal={itemToEdit?.item_variety_name}
                  dropDown={itemtypeList}
                  optionSelect={selectedItemType}
                />
                <small className="text-red-500">{errors?.item_variety_id && errors.item_variety_id.message}</small>
              </div>
            </div>
          </div>

          {/* ITEM INFORMATION SECTION */}
          <div className="mt-6 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
            <div className="col-span-1 w-full">
              <div className="w-full">
                <label className="text-sm text-gray-600 font-medium">Name *</label>
                <input
                  className="-mt-1 h-11 w-full text-sm placeholder:text-sm placeholder:text-gray-400 rounded-md outline-none border-gray-300 focus:border-transparent focus:ring-[2px] focus:ring-blue-500"
                  type="text"
                  placeholder="Item name"
                  {...register('item_name', { required: 'Item name is required' })}
                />
              </div>
              <small className="text-red-500">{errors?.item_name && errors.item_name.message}</small>

              <div className="mt-4">
                <label className="text-sm text-gray-600 font-medium">Category *</label>
                <div className="-mt-1">
                  <GeneralDropDown
                    {...register('item_category_id', { required: 'Item Category required' })}
                    manage={true}
                    defaultVal={itemToEdit?.item_category_name}
                    manageList={manageCategoryList}
                    dropDown={productCategory}
                    optionSelect={selectedCategory}
                  />
                </div>
              </div>

              <div className="mt-[26px]">
                <label className="text-sm text-gray-600 font-medium">
                  Dimension <i>(Length X Width X Height)</i>
                </label>
                <div className="flex flex-row items-center">
                  <div className="">
                    <input
                      type="number"
                      className="w-full z-10 h-10 text-sm rounded-md outline-none border-gray-300 focus:border-transparent focus:ring-[2px] focus:ring-blue-500"
                      {...register('item_dimension_length')}
                    />
                  </div>
                  <div className="ml-2 flex flex-row items-center space-x-1">
                    <div className="text-xs font-medium text-gray-700">X</div>
                    <input
                      type="number"
                      className="w-full z-10 h-10 text-sm rounded-md outline-none border-gray-300 focus:border-transparent focus:ring-[2px] focus:ring-blue-500"
                      {...register('item_dimension_width')}
                    />
                  </div>
                  <div className="ml-3 flex flex-row items-center space-x-1">
                    <div className="text-xs font-medium text-gray-700">X</div>
                    <input
                      type="number"
                      className="w-full z-10 h-10 text-sm rounded-md outline-none border-gray-300 focus:border-transparent focus:ring-[2px] focus:ring-blue-500"
                      {...register('item_dimension_height')}
                    />
                  </div>
                  <div className="ml-2">
                    <DimentionSelect
                      defaultVal={itemToEdit?.item_dimension_unit_name}
                      selectedDimension={selectedDimensionUnit}
                      productDimension={productDimension}
                    />
                  </div>
                </div>
              </div>

              <div className="mt-7">
                <label className="text-sm text-gray-600 font-medium">UPC</label>
                <input
                  {...register('item_upc')}
                  className="-mt-1 h-11 w-full text-sm rounded-md outline-none border-gray-300 focus:border-transparent focus:ring-[2px] focus:ring-blue-500"
                  type="text"
                  placeholder=""
                />
              </div>
              <div className="mt-4">
                <label className="text-sm text-gray-600 font-medium">Stock out</label>
                <FormGroup>
                  <FormControlLabel
                    control={<Switch color="primary" checked={outOfstock} onChange={onOutOfStockChange} name="item_stock_out" />}
                    label={outOfstock ? ' Item is out of Stock ' : 'Item in stock'}
                  />
                </FormGroup>
              </div>

              <div className="mt-4">
                <label className="text-sm text-gray-600 font-medium">Product sharing status</label>
                <FormGroup>
                  <FormControlLabel
                    control={<Switch color="primary" checked={productShare} onChange={onProductIsGrooPoolChange} name="gropool" />}
                    label={productShare ? ' GroPool ' : ' GroPool'}
                  />
                </FormGroup>
              </div>
            </div>

            <div className="col-span-1 w-full">
              <div className=" ">
                <div>
                  <label className="text-sm text-gray-600 font-medium">Sku</label>{' '}
                  <input
                    className="-mt-1 h-11 w-full placeholder:text-sm text-sm placeholder:text-gray-400 rounded-md outline-none border-gray-300 focus:border-transparent focus:ring-[2px] focus:ring-blue-500"
                    type="text"
                    placeholder="Sku"
                    {...register('item_sku', { required: 'Sku is required' })}
                  />
                </div>
                <small className="text-red-500">{errors?.item_sku && errors.item_sku.message}</small>

                <div className="mt-4">
                  <label className="text-sm text-gray-600 font-medium">Unit</label>
                  <div className="-mt-1 w-full">
                    <GeneralDropDown
                      manage={true}
                      defaultVal={itemToEdit?.item_unit_name}
                      manageList={manageUnitList}
                      {...register('item_unit_id', { required: 'Unit is required' })}
                      dropDown={productUnit}
                      optionSelect={selectedUnitType}
                    />
                    <small className="ml-3 text-red-500">{errors?.item_unit_id && errors.item_unit_id.message}</small>
                  </div>
                </div>
                <div className="mt-4">
                  <label className="relative text-sm text-gray-600 font-medium">Weight</label>
                  <span className="w-full flex flex-row items-center space-x-1">
                    <input
                      {...register('item_weight')}
                      step="0.01"
                      className="h-11 w-full z-10 text-sm rounded-md outline-none border-gray-300 focus:border-transparent focus:ring-[2px] focus:ring-blue-500"
                      type="number"
                      placeholder=""
                    />
                    <span className="">
                      <DimentionSelect
                        defaultVal={itemToEdit?.item_weight_name}
                        selectedDimension={selectedProductWeight}
                        productDimension={productWeight}
                      />
                    </span>
                  </span>
                </div>
                <div className="mt-4">
                  <label className="text-sm text-gray-600 font-medium">EAN</label>
                  <input
                    {...register('item_ean')}
                    className="h-11 z-10 w-full text-sm rounded-md outline-none border-gray-300 focus:border-transparent focus:ring-[2px] focus:ring-blue-500"
                    type="text"
                    placeholder=""
                  />
                </div>
                <div className="mt-4">
                  <label className="text-sm text-gray-600 font-medium">Product sharing slot</label>
                  <ImageSlotSelection defaultVal={itemToEdit?.sharing_slot_id} slot_info={slot_info} onSlotSelection={onSlotSelection} />
                </div>
              </div>

              <div className="mt-4">
                <label className="text-sm text-gray-600 font-medium">Flash Sales</label>
                <FormGroup>
                  <FormControlLabel
                    control={
                      <Switch color="primary" checked={flashSales} onChange={onFlashSalesChange} name="flash_sales_status_id" />
                    }
                    label={flashSales ? ' flash sales ' : ''}
                  />
                </FormGroup>
              </div>
            </div>

            <div className="col-span-1 w-full">
              <div>
                <div className="">
                  <label className="text-sm text-gray-600 font-medium">Brand</label>
                  <div className="-mt-1 w-full">
                    <GeneralDropDown
                      manage={true}
                      defaultVal={itemToEdit?.item_brand_name}
                      manageList={manageBrandList}
                      dropDown={productBrand}
                      optionSelect={selectedBrand}
                    />
                  </div>
                </div>
                <div className="">
                  <label className="text-sm text-gray-600 font-medium">Manufacturer</label>
                  <div className="-mt-1 w-full">
                    <GeneralDropDown
                      manage={true}
                      defaultVal={itemToEdit?.manufacturer_name}
                      manageList={manageManufacturer}
                      dropDown={productManufacturer}
                      optionSelect={selectedManufacturer}
                    />
                  </div>
                </div>
                <div className="mt-4">
                  <label className="text-sm text-gray-600 font-medium">ISBN</label>
                  <input
                    {...register('item_isbn')}
                    className="h-11 w-full text-sm rounded-md outline-none border-gray-300 focus:border-transparent focus:ring-[2px] focus:ring-blue-500"
                    type="text"
                    placeholder=""
                  />
                </div>
                <div className="mt-4">
                  <label className="text-sm text-gray-600 font-medium">MPN</label>
                  <input
                    {...register('item_mpn')}
                    className="h-11 w-full text-sm rounded-md outline-none border-gray-300 focus:border-transparent focus:ring-[2px] focus:ring-blue-500"
                    type="text"
                    placeholder=""
                  />
                </div>
              </div>

              <div className="mt-4">
                <label className="text-sm text-gray-600 font-medium">Top Deals Sales</label>
                <FormGroup>
                  <FormControlLabel
                    control={
                      <Switch color="primary" checked={topDeals} onChange={onTopDealsChange} name="top_deal_status_id" />
                    }
                    label={topDeals ? ' Top Deal ' : ' '}
                  />
                </FormGroup>
              </div>
            </div>
          </div>

          {/* OTHER INFORMATION */}
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
            <div className="col-span-1 w-full">
              <div className="mt-4 flex flex-row items-center space-x-1.5">
                <input
                  onChange={e => setSalesCheck(e.target.checked)}
                  type="checkbox"
                  checked={salesCheck}
                  className="h-4 w-4 border-[1px] border-gray-500 rounded-sm focus:ring-0 ring-0 cursor-pointer"
                />
                <div className="text-sm font-medium text-gray-700">Sales Information</div>
              </div>

              {salesCheck && (
                <div className="w-full">
                  <div className="mt-4 w-full">
                    <label className="relative text-[#F17E7E] text-sm font-medium">Selling Price</label>
                    <span className="w-full flex flex-row items-center space-x-1">
                      <input
                        {...register('sales_rate')}
                        className="h-11 z-10 w-full text-sm rounded-md outline-none border-gray-300 focus:border-transparent focus:ring-[2px] focus:ring-blue-500"
                        type="text"
                        placeholder=""
                      />
                      <span className="">
                        <DimentionSelect selectedDimension={selectDefaultCurrency} productDimension={defaultCurrency} />
                      </span>
                    </span>
                  </div>
                  <div className="mt-4">
                    <label className="w-full flex flex-row items-center space-x-1">Market Price</label>
                    <span className="w-full flex flex-row items-center space-x-1">
                      <input
                        {...register('market_rate')}
                        className="h-11 z-10 w-full text-sm rounded-md outline-none border-gray-300 focus:border-transparent focus:ring-[2px] focus:ring-blue-500"
                        type="text"
                        placeholder=""
                      />
                      <span className="">
                        <DimentionSelect selectedDimension={selectDefaultCurrency} productDimension={defaultCurrency} />
                      </span>
                    </span>
                  </div>
                  <div className="mt-4">
                    <label className="relative text-[#F17E7E] text-sm font-medium">Sales Account</label>
                    <div className="w-full">
                      <GeneralDropDown
                        manage={false}
                        dropDown={salesAccounts}
                        defaultVal={itemToEdit?.sales_accounts_name}
                        optionSelect={selectedSalesAccount}
                      />
                    </div>
                  </div>
                  <div className="mt-4">
                    <label className=" text-gray-600 text-sm font-medium">Description</label>
                    <textarea
                      {...register('sales_description')}
                      className="z-10 w-full text-sm rounded-md outline-none border-gray-300 focus:border-transparent focus:ring-[2px] focus:ring-blue-500"
                      role="4"
                      type="text"
                      placeholder="Write a Description"
                    />
                  </div>
                  <div className="mt-4">
                    <label className="relative text-[#F17E7E] text-sm font-medium">Sales Tax</label>
                    <div className="w-full">
                      <GeneralDropDown
                        manage={true}
                        defaultVal={itemToEdit?.sales_tax_name}
                        manageList={manageTaxList}
                        dropDown={taxList}
                        optionSelect={salesTaxList}
                      />
                    </div>
                  </div>
                </div>
              )}
            </div>

            <div className="col-span-1 w-full">
              <div className="mt-4 flex flex-row items-center space-x-1.5">
                <input
                  onChange={e => setPurchaseCheck(e.target.checked)}
                  type="checkbox"
                  checked={purchaseCheck}
                  className="h-4 w-4 border-[1px] border-gray-500 rounded-sm focus:ring-0 ring-0 cursor-pointer"
                />
                <div className="text-sm font-medium text-gray-700">Purchase Information</div>
              </div>

              {purchaseCheck && (
                <span>
                  <div className="mt-4">
                    <label className="w-full text-gray-600 text-sm font-medium">Cost Price</label>
                    <span className="w-full flex flex-row items-center space-x-1">
                      <input
                        {...register('cost_rate')}
                        className="h-11 z-10 w-full text-sm rounded-md outline-none border-gray-300 focus:border-transparent focus:ring-[2px] focus:ring-blue-500"
                        type="text"
                        placeholder=""
                      />
                      <span className="dimenSelect_input ">
                        <DimentionSelect selectedDimension={selectDefaultCurrency} productDimension={defaultCurrency} />
                      </span>
                    </span>
                  </div>
                  <div className="mt-4">
                    <label className="w-full text-[#F17E7E] text-sm font-medium">Purchase Account</label>
                    <div className="w-full">
                      <GeneralDropDown
                        manage={false}
                        defaultVal={itemToEdit?.purchase_account_name}
                        dropDown={purchaseAccounts}
                        optionSelect={selectedPurchaseAccount}
                      />
                    </div>
                  </div>
                  <div className="mt-4">
                    <label className="w-full text-gray-600 text-sm font-medium">Description</label>
                    <textarea
                      {...register('purchase_description')}
                      className="z-10 w-full text-sm rounded-md outline-none border-gray-300 focus:border-transparent focus:ring-[2px] focus:ring-blue-500"
                      role="4"
                      type="text"
                      maxLength="1000"
                      placeholder="Write a Description"
                    />
                  </div>
                  <div className="mt-4">
                    <label className="w-full text-[#F17E7E] text-sm font-medium">Purchase Tax </label>
                    <div className="w-full">
                      <GeneralDropDown
                        manage={true}
                        manageList={manageTaxList}
                        defaultVal={itemToEdit?.purchase_tax_name}
                        dropDown={taxList}
                        optionSelect={selectPurchaseTax}
                      />
                    </div>
                  </div>
                </span>
              )}
            </div>

            <div className="col-span-1 w-full">
              <div className="mt-4 flex flex-row items-center space-x-1.5">
                <input
                  onChange={e => addTrackingForItem(e.target.checked)}
                  type="checkbox"
                  checked={trackCheck}
                  className="h-4 w-4 border-[1px] border-gray-500 rounded-sm focus:ring-0 ring-0 cursor-pointer"
                />
                <div className="text-sm font-medium text-gray-700">Track inventory for this Item </div>
              </div>

              {trackCheck && (
                <span>
                  <AddItemTrackingTypeCheckRadioButton
                    val={itemToEdit?.item_tracking_type_id}
                    addItemTrackingType={addItemTrackingType}
                  ></AddItemTrackingTypeCheckRadioButton>

                  <div className="mt-2">
                    <label className="relative text-gray-600 text-sm font-medium">Minimum Payment</label>
                    <span className="w-full flex flex-row items-center space-x-1">
                      <input
                        {...register('minimum_payment')}
                        className="h-11 z-10 w-full text-sm rounded-md outline-none border-gray-300 focus:border-transparent focus:ring-[2px] focus:ring-blue-500"
                        type="text"
                        placeholder=""
                      />
                      <span className="dimenSelect_input ">
                        <DimentionSelect selectedDimension={selectDefaultCurrency} productDimension={defaultCurrency} />
                      </span>
                    </span>
                  </div>
                  <div className="mt-4">
                    <label className="relative text-[#F17E7E] text-sm font-medium">Inventory Account</label>
                    <div className="w-full">
                      <GeneralDropDown
                        manage={false}
                        defaultVal={itemToEdit?.inventory_accounts_name}
                        dropDown={inventoryAccounts}
                        optionSelect={selectedInventoryAccount}
                      />
                    </div>
                  </div>
                  <div className="mt-4">
                    <label className="relative text-gray-600 text-sm font-medium">Reorder Point</label>
                    <input
                      {...register('reorder_quantity')}
                      className="h-11 z-10 w-full text-sm rounded-md outline-none border-gray-300 focus:border-transparent focus:ring-[2px] focus:ring-blue-500"
                      type="number"
                      placeholder=""
                    />
                  </div>
                  <div className="mt-4">
                    <label className="relative text-[#F17E7E] text-sm font-medium">Preferred Vendor</label>
                    <div className="w-full">
                      <GeneralDropDown
                        manage={true}
                        defaultVal={itemToEdit?.preferred_vendor_name}
                        manageList={manageVendorList}
                        dropDown={vendors}
                        optionSelect={selectedVendor}
                      />
                    </div>
                  </div>
                </span>
              )}
            </div>
          </div>

          <section className="flex my-5 justify-between">
            <a onClick={() => navigate(-1)} style={{ color: '#F17E7E' }} className="py-2 btn px-4 text-sm rounded ">
              Cancel
            </a>
            <button type="submit" className="py-2 px-6 text-sm rounded-md bg-blue-500 text-white font-medium">
              Save
            </button>
          </section>
        </div>
      </form>
    </>
  );
}

export default AddItemForm;
